import React from "react";

const services = [
  {
    title: "PLANNING | BUILDING PLAN PASSING (AMC | AUDA | TPO)",
    desc: "We assist with complete planning and official building plan approvals, ensuring a smooth process without any difficulties."
  },
  {
    title: "SURVEYING",
    desc: "We provide professional land surveying services ensuring accurate measurements, mapping, and property boundary identification."
  },
  {
    title: "PROPERTY VALUATION",
    desc: "Get accurate and expert property valuation based on location, development potential, and market insights."
  },
  {
    title: "LAND NA SERVICES",
    desc: "Expert guidance for NA (Non-Agricultural) land conversion, documentation, compliance, and property transactions."
  },
  {
    title: "PROPERTY BUY | SELL | RENT",
    desc: "End-to-end real estate solutions for buying, selling, and renting properties with full transparency and support."
  },
  {
    title: "PROPERTY INVESTMENT – PRE-LAUNCH & PRE-LEASE | RESALE",
    desc: "We offer exclusive investment opportunities in pre-launch, pre-lease, and resale properties for high-return potential."
  }
];

const OurServices = () => {
  return (
    <div
      id="service"
      className="w-full py-10 px-4 bg-gradient-to-b from-white to-gray-400 flex items-center"
    >
      <div className="max-w-7xl mx-auto py-10 sm:px-6 lg:px-8">
        <h2 className="text-4xl font-bold text-gray-800 mb-4">
          Our <span className="text-blue-900">Services</span>
        </h2>

        <p className="text-lg text-gray-700 mb-10 max-w-3xl">
          We offer a wide range of real estate services designed to meet the
          unique needs of every client. Here are some of the key services we
          provide.
        </p>

        <div className="container mx-auto px-4">
          <div className="flex flex-wrap -mx-4">

            {services.map((service, index) => (
              <div key={index} className="w-full md:w-1/3 px-4 mb-8">
                <div className="bg-white rounded-lg shadow-lg h-full">
                  <div className="p-5">
                    <h2 className="text-lg font-bold text-gray-800 mb-3">
                      {service.title}
                    </h2>
                    <p className="text-gray-700 leading-relaxed">
                      {service.desc}
                    </p>
                  </div>
                </div>
              </div>
            ))}

          </div>
        </div>
      </div>
    </div>
  );
};

export default OurServices;
